function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrave = function SvgBrave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48.8 58.3"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.6)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "brave_svg__a",
    x1: -104.049,
    x2: -103.049,
    y1: 226.584,
    y2: 226.584,
    gradientTransform: "matrix(48.7978 0 0 -58.296 5076.76 13238.078)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#f50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    style: {
      stopColor: "#ff2000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff2000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.5 14 1.3-3.4s-1.7-1.9-3.8-4-6.5-.9-6.5-.9l-5-5.8H15l-5 5.8s-4.4-1.2-6.5.9-3.8 4-3.8 4L1.1 14l-1.7 5s5 19.4 5.6 21.8c1.2 4.7 2 6.5 5.2 8.8s9.3 6.5 10.2 7.1c1 .6 2.2 1.7 3.3 1.7s2.3-1.1 3.3-1.7 7-4.7 10.2-7.1 4.1-4.2 5.2-8.8C43 38.4 48 19 48 19z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#brave_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8 36.3c.3 0 2.5.8 4.2 1.7s3 1.5 3.4 1.8.2.7-.2 1-5.2 4.1-5.7 4.5-1.2 1.1-1.6 1.1-1.2-.7-1.6-1.1c-.5-.4-5.3-4.3-5.7-4.5-.4-.3-.6-.7-.2-1s1.6-.9 3.4-1.8c1.5-1 3.7-1.7 4-1.7m0-27.4c.2 0 1.1.1 2.4.5 1.5.5 3 1.1 3.8 1.1s6.2-1.1 6.2-1.1 6.4 7.9 6.4 9.6-.8 2.1-1.6 3-4.4 4.7-4.8 5.2c-.5.5-1.4 1.2-.8 2.6.6 1.3 1.4 3.1.5 4.8s-2.5 2.9-3.5 2.7-3.4-1.5-4.2-2c-.9-.6-3.6-2.9-3.6-3.8s2.8-2.5 3.4-2.8c.5-.4 2.9-1.8 3-2.3 0-.5 0-.7-.7-2.1s-2-3.2-1.8-4.4 2.3-1.8 3.7-2.4c1.5-.6 4.3-1.6 4.6-1.8.4-.2.3-.3-.8-.4s-4.1-.5-5.5-.1-3.7 1-3.9 1.3-.4.3-.2 1.4 1.2 6.3 1.3 7.2.3 1.5-.7 1.8c-1 .2-2.6.6-3.2.6s-2.2-.4-3.2-.6-.8-.8-.7-1.8c.1-.9 1.1-6.1 1.3-7.2s0-1.1-.2-1.4-2.5-.9-3.9-1.3-4.4 0-5.5.1-1.2.3-.8.4c.4.2 3.2 1.2 4.6 1.8 1.5.6 3.5 1.2 3.7 2.4s-1.1 3-1.8 4.4-.7 1.5-.7 2.1c0 .5 2.4 1.9 3 2.3.5.4 3.4 2 3.4 2.8 0 .9-2.8 3.2-3.6 3.8-.9.6-3.2 1.8-4.2 2s-2.6-1-3.5-2.7-.1-3.5.5-4.8-.4-2.1-.8-2.6c-.5-.5-4-4.3-4.8-5.2S5 20.7 5 19s6.4-9.6 6.4-9.6 5.4 1.1 6.2 1.1 2.3-.6 3.8-1.1c1.3-.5 2.2-.5 2.4-.5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brave_svg__b",
    x1: -103.587,
    x2: -102.608,
    y1: 213.316,
    y2: 213.316,
    gradientTransform: "matrix(40.5021 0 0 -10.5044 4199.906 2246.005)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff452a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff2000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m37.6 5.8-5-5.8H15l-5 5.8s-4.4-1.2-6.5.9c0 0 5.9-.5 7.9 2.8 0 0 5.4 1.1 6.2 1.1s2.3-.6 3.8-1.1 2.4-.5 2.4-.5 1 0 2.4.5c1.5.5 3 1.1 3.8 1.1s6.2-1.1 6.2-1.1c2-3.3 7.9-2.8 7.9-2.8-2.1-2.2-6.5-.9-6.5-.9",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#brave_svg__b)"
    }
  })));
};
export default SvgBrave;